import httpClient from "Api/httpClient";

const END_POINT = "/dashboard_widgets";

const getDashboardWidgets = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getDashboardWidget = (widget_id) => {
    if (!widget_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + widget_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printDashboardWidget = (widget_id) => {
    if (!widget_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?widget_id=" + widget_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createDashboardWidgets = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateDashboardWidgets = (payload, widget_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + widget_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteDashboardWidgets = (widget_id) => {
    const DELETE_END_POINT = END_POINT + "/" + widget_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getDashboardWidgets, getDashboardWidget, printDashboardWidget, createDashboardWidgets, updateDashboardWidgets, deleteDashboardWidgets };
